<template>
	<div class="popup-boms">
		<template v-if="d_current_bom">
			<div class="popup-boms-head">
				<h3 class="popup-boms-title">{{d_current_bom.strTitle}}</h3>
				<br>
				<h5 class="popup-boms-title">{{m_get_title()}}</h5>
			</div>
			<div>
				<div class="popup-boms-body" v-if="d_candy != null">
					<div class="boms">
						<div :id="option.strOptionItemId" v-for="option in d_current_bom.Options" :key="option.strTitle" class="bom" @click="m_add_one_boom_click(option)" :style="m_current_max_qty() == 1 ? 'cursor:pointer;' : ''">
							<span class="bom-title">{{option.strTitle}} {{option.intPrice > 0? '$' + (option.intPrice / 100) : '' }}</span>
							<div class="bom-img">
								<img :src="$root.d_get_url_candy_booms_images + option.strMCode +'.png?v=' + $root.d_get_date_version_cache" alt="">
							</div>
							<div class="bom-btns" v-if="m_current_max_qty() > 1">
								<div class="bom-qty">{{option.intQty}}</div>
								<button class="bom-btn bom-btn_minus" @click="m_remove_click(option)"></button>
								<button class="bom-btn bom-btn_plus" @click="m_add_click(option)" ></button>
							</div>
							<div class="bom-btns bom-btns_max1" v-else :class="{ 'bom-btns_max1_checked' : option.intQty > 0 }"></div>
						</div>
					</div>
				</div>
			</div>  
			<div>
				<div class="popup-boms-footer">
					<button v-if="this.d_current_index > 0" class="popup-boms-btn white" @click.prevent="m_back">VOLVER</button>
					<button :disabled="m_current_min_qty() != 0 && !d_continue" class="popup-boms-btn" @click.prevent="m_next">CONTINUAR</button>
					<button type="button" class="popup-candy-alert__close"  @click="m_close()"></button> 
				</div>
			</div>
		</template>  
	</div>
</template>
<script>
	import Vue from 'vue'
	require("./../assets/jquery.bpopup.min.js");
	import * as functionsCandys from "../functionsCandys";

	export default {
		name: "popupboms", 
		data: function() {
			return {
				d_candy: null,
				d_option: null,
				d_bpopup: null,
				d_current_bom: null,
				d_current_index: -1,
				d_selected_boms: [],
				d_current_selected_bom: null,
				d_extra_qty_min: 0,
				d_extra_qty_max: 0,
				d_continue: false,
			};
		},
		watch: {
		},
		methods: {
		
	//Seteo el object con los atributos a mostrar dependiendo del msj.
	m_open: function(candy, option) {
		this.d_continue = false;
		this.d_current_index = -1;
		this.d_current_bom = null;
		this.d_current_selected_bom = null;
		this.d_selected_boms = [];     
		this.d_extra_qty_min= 0,
		this.d_extra_qty_max= 0,
		this.d_bpopup && this.d_bpopup.close();

		this.d_candy = candy;
		this.d_option = option;
		if(this.m_is_options()){
			this.m_next();
			this.d_bpopup = $(this.$el).bPopup({
				modalClose: false,
				closeClass: "close, .popup-candy-alert__close",
				transitionClose: 'fadeIn',
				onClose: function() {
					$(this.$el).remove();
					this.d_current_bom = null;
				}
			});
			this.d_bpopup.reposition(100);
		}else{
			this.m_finish();
		}
	},
	m_close: function() { 
		this.d_candy = null;
		this.d_option = null;
		this.d_continue = false;
		this.d_current_index = -1;
		//this.d_current_bom = null;
		this.d_current_selected_bom = null;
		this.d_selected_boms = [];     
		this.d_extra_qty_min= 0,
		this.d_extra_qty_max= 0,
		this.d_bpopup && this.d_bpopup.close();
	},  
	m_add_click: function(option){
		if(this.d_current_selected_bom && this.m_qty_options(this.d_current_selected_bom) < this.m_current_max_qty()){       
			var opt = this.d_current_selected_bom.Options.find(o => o.strOptionItemId == option.strOptionItemId);
			if(opt){
				opt.intQty = opt.intQty + 1;       
			}else{
				option.intQty = 1;
				this.d_current_selected_bom.Options.push(option); 
			}
			if(this.m_qty_options(this.d_current_selected_bom) >= this.m_current_min_qty()){
				this.d_continue = true;
			}
		}       
	},
	m_remove_click: function(option){
		var opt = this.d_current_selected_bom.Options.find(o => o.strOptionItemId == option.strOptionItemId);
		if(opt){
			opt.intQty = opt.intQty - 1;
			if(opt.intQty == 0){
				var removeItemIndex = -1;
				removeItemIndex = this.d_current_selected_bom.Options.indexOf(opt)
				removeItemIndex !== -1 && this.d_current_selected_bom.Options.splice(removeItemIndex,1); 
			}
			if(this.m_qty_options(this.d_current_selected_bom) < this.m_current_min_qty()){
				this.d_continue = false;
			} 
		}     
	},
	m_add_one_boom_click: function(option){
		if (this.m_current_max_qty() == 1){
			this.d_current_selected_bom.Options.forEach(o => {       
				this.m_remove_click(o);        
			});    
			this.m_add_click(option);
		}
	},
	m_check_condition: function(Conditionals){
		this.d_extra_qty_min = 0;
		this.d_extra_qty_max = 0;
		if (Conditionals.length >0){
			//por ahora tomo que solo puede haber 1
			var condition = Conditionals[0];

			this.d_selected_boms.forEach(bom => {
				bom.Options.forEach(option =>{
					if (option.strOptionItemId == condition.strConditionOptionItemId){
						this.d_extra_qty_min = condition.intMinQty * option.intQty;
						this.d_extra_qty_max = condition.intMaxQty * option.intQty;
					}
				});
				
			});
		}
	},
	m_back: function(){	
		this.d_continue = true;
		this.d_current_index = this.d_current_index - 1;
		this.d_current_bom = $.extend(true, {}, this.d_candy.BOMs[this.d_current_index]);
		this.d_current_selected_bom = $.extend(true, {}, this.d_current_bom);	
		this.d_current_bom.Options.forEach(option =>{
			Vue.set(option,"intQty",0);         
		})
		this.d_current_selected_bom.Options = [];  
		var selBom = this.d_selected_boms.find(b=> b.strBOMItemId == this.d_current_bom.strBOMItemId);		

		if (selBom){
			selBom.Options.forEach(option => {
				var opt = this.d_current_bom.Options.find(o => o.strOptionItemId == option.strOptionItemId);
				if(opt){
					opt.intQty = option.intQty;       
					this.d_current_selected_bom.Options.push(opt); 
				}
			});
			//lo limpio del registo de seleccionados. Si vuelvo para atras, ya esta borrado y si continuo, lo agrega con los nuevos datos
			var removeItemIndex = -1;
			removeItemIndex = this.d_selected_boms.indexOf(selBom)
			removeItemIndex !== -1 && this.d_selected_boms.splice(removeItemIndex,1); 
		}
		this.m_check_condition(this.d_current_bom.Conditionals);
	},
	m_next: function(){
		(this.d_current_selected_bom && this.d_current_selected_bom.Options.length) && this.d_selected_boms.push(this.d_current_selected_bom);			
		if(this.d_current_index +1 == this.d_candy.BOMs.length){
			this.m_finish();
		}else{
			this.d_continue = false;
			this.d_current_index = this.d_current_index + 1;
			this.d_current_bom = $.extend(true, {}, this.d_candy.BOMs[this.d_current_index]);
			this.d_current_selected_bom = $.extend(true, {}, this.d_current_bom);

			this.m_check_condition(this.d_current_bom.Conditionals);

			this.d_current_bom.Options.forEach(option =>{
				Vue.set(option,"intQty",0);         
			})
			this.d_current_selected_bom.Options = [];       

			if (this.d_current_bom.Conditionals.length >0 && this.d_current_bom.intMaxQty==0 && this.d_extra_qty_max==0){
				this.m_next();
				return;
			}
			if(this.d_current_bom.Options.length == 0){
				this.m_next();
			}
		
		}
	},
	m_finish: function(){
		this.$root.d_cart_candys = functionsCandys.UpdateOrder(this.$root.d_cart_candys, this.d_candy.strMCode, this.d_candy.strBarcode, this.d_option.intRecogId, this.d_option.intButtonQty, this.d_selected_boms, this.d_option.intPromoId);
		this.$root.m_update_group_rule_candy(this.d_candy, true);
		this.$root.m_calculate_total_candy();  
	  //Actualizo puntos.
		this.$root.d_total_member_points = this.$root.d_total_member_points - this.d_option.intPoints;     
	  	this.m_close();     
	},
	m_is_options: function(){
		var isOptions = false;
		if(this.d_candy.BOMs){
			this.d_candy.BOMs.forEach(element => {
				if(element.Options.length > 0){
					isOptions = true;
				}
			});
		}
		return isOptions;
	},
	m_current_max_qty: function(){
		return Number(this.d_current_bom.intMaxQty) + Number(this.d_extra_qty_max);
	},
	m_current_min_qty: function(){
		return Number(this.d_current_bom.intMinQty) + Number(this.d_extra_qty_min);
	},
	m_qty_options: function(bom){
		var qty = 0;
		if(bom){
			bom.Options.forEach(option => {                
				qty += option.intQty; 
			});
		}
		return qty;
	},
	m_get_title: function(){
		//if (this.d_current_selected_bom != null){
			if(this.m_current_min_qty() == 0){	
				return "SELECCIONÁ HASTA " +  this.m_current_max_qty() + (this.m_current_max_qty() == 1 ? " " + this.d_current_selected_bom.strElement : " " + this.d_current_selected_bom.strElements) + " O CONTINUA SIN AGREGAR " + this.d_current_selected_bom.strElements;
			}else{
				return "SELECCIONÁ " + (this.m_current_min_qty() - this.m_qty_options(this.d_current_selected_bom)) + (this.m_current_min_qty() - this.m_qty_options(this.d_current_selected_bom) == 1 ? " " + this.d_current_selected_bom.strElement : " " + this.d_current_selected_bom.strElements) + " PARA CONTINUAR";
			}
		/*}else{
			return "";
		}*/

	}
}
};
</script>



// WEBPACK FOOTER //
// src/components/PopupBoms.vue